import { render, staticRenderFns } from "./ManageCollection.vue?vue&type=template&id=42412b0d&"
import script from "./ManageCollection.vue?vue&type=script&lang=js&"
export * from "./ManageCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports